export const CONTACTS_FIELD_TYPES = {
    CONTACTS_COMPANY: 'CONTACTS_COMPANY',
    CONTACTS_POSITION: 'CONTACTS_POSITION',
    CONTACTS_TAX_ID: 'CONTACTS_TAX_ID',
    CONTACTS_FIRST_NAME: 'CONTACTS_FIRST_NAME',
    CONTACTS_LAST_NAME: 'CONTACTS_LAST_NAME',
    CONTACTS_EMAIL: 'CONTACTS_EMAIL',
    CONTACTS_BIRTHDATE: 'CONTACTS_BIRTHDATE',
    CONTACTS_PHONE: 'CONTACTS_PHONE',
    CONTACTS_ADDRESS: 'CONTACTS_ADDRESS',
    CONTACTS_SUBSCRIBE: 'CONTACTS_SUBSCRIBE'
};
// Challenges field keys (CHALLENGES_*) differ from their values (QUIZ_*) because
// these fields were originally built for the Challenges product under the QUIZ_ prefix.
// We renamed the keys to CHALLENGES_ to free up the QUIZ_ namespace for our own quiz fields,
// but the values stay as QUIZ_* since they're persisted in form schemas.
export const CHALLENGES_FIELD_TYPES = {
    CHALLENGES_MULTI_CHOICE: 'QUIZ_MULTI_CHOICE',
    CHALLENGES_SINGLE_CHOICE: 'QUIZ_SINGLE_CHOICE',
    CHALLENGES_SHORT_TEXT: 'QUIZ_SHORT_TEXT',
    CHALLENGES_LONG_TEXT: 'QUIZ_LONG_TEXT',
    CHALLENGES_NUMBER: 'QUIZ_NUMBER',
    CHALLENGES_FILE_UPLOAD: 'QUIZ_FILE_UPLOAD',
    CHALLENGES_IMAGE_CHOICE: 'QUIZ_IMAGE_CHOICE'
};
export const QUIZ_FIELD_TYPES = {
    QUIZ_TEXT_INPUT: 'PLATFORM_QUIZ_TEXT_INPUT',
    QUIZ_NUMBER_INPUT: 'PLATFORM_QUIZ_NUMBER_INPUT',
    QUIZ_RADIO_GROUP: 'PLATFORM_QUIZ_RADIO_GROUP',
    QUIZ_CHECKBOX_GROUP: 'PLATFORM_QUIZ_CHECKBOX_GROUP',
    QUIZ_IMAGE_CHOICE: 'PLATFORM_QUIZ_IMAGE_CHOICE'
};
export const DEXT_FIELD_TYPES = {
    DEXT_TEXT_INPUT: 'DEXT_TEXT_INPUT',
    DEXT_TEXT_AREA: 'DEXT_TEXT_AREA',
    DEXT_DROPDOWN: 'DEXT_DROPDOWN',
    DEXT_URL_INPUT: 'DEXT_URL_INPUT',
    DEXT_RADIO_GROUP: 'DEXT_RADIO_GROUP',
    DEXT_NUMBER_INPUT: 'DEXT_NUMBER_INPUT',
    DEXT_CHECKBOX: 'DEXT_CHECKBOX',
    DEXT_CHECKBOX_GROUP: 'DEXT_CHECKBOX_GROUP',
    DEXT_EMAIL: 'DEXT_EMAIL',
    DEXT_PHONE: 'DEXT_PHONE',
    DEXT_RATING_INPUT: 'DEXT_RATING_INPUT',
    DEXT_DATE_PICKER: 'DEXT_DATE_PICKER',
    DEXT_DATE_TIME_INPUT: 'DEXT_DATE_TIME_INPUT',
    DEXT_TAGS: 'DEXT_TAGS'
};
export const ECOM_FIELD_TYPES = {
    ECOM_ADDITIONAL_INFO: 'ECOM_ADDITIONAL_INFO',
    ECOM_ADDRESS: 'ECOM_ADDRESS',
    ECOM_FULL_NAME: 'ECOM_FULL_NAME',
    ECOM_PHONE: 'ECOM_PHONE',
    ECOM_COMPANY_NAME: 'ECOM_COMPANY_NAME',
    ECOM_EMAIL: 'ECOM_EMAIL',
    ECOM_SUBSCRIPTION: 'ECOM_SUBSCRIPTION'
};
export const BOOKINGS_FIELD_TYPES = {
    BOOKINGS_FIRST_NAME: 'BOOKINGS_FIRST_NAME',
    BOOKINGS_LAST_NAME: 'BOOKINGS_LAST_NAME',
    BOOKINGS_EMAIL: 'BOOKINGS_EMAIL',
    BOOKINGS_PHONE: 'BOOKINGS_PHONE',
    BOOKINGS_ADDRESS: 'BOOKINGS_ADDRESS'
};
export const COMMON_FIELD_TYPES = {
    TEXT_INPUT: 'TEXT_INPUT',
    NUMBER_INPUT: 'NUMBER_INPUT',
    URL_INPUT: 'URL_INPUT',
    TEXT_AREA: 'TEXT_AREA',
    DATE_INPUT: 'DATE_INPUT',
    DATE_TIME_INPUT: 'DATE_TIME_INPUT',
    TIME_INPUT: 'TIME_INPUT',
    RADIO_GROUP: 'RADIO_GROUP',
    CHECKBOX_GROUP: 'CHECKBOX_GROUP',
    FILE_UPLOAD: 'FILE_UPLOAD',
    CHECKBOX: 'CHECKBOX',
    DROPDOWN: 'DROPDOWN',
    NESTED_FORM: 'NESTED_FORM',
    MULTILINE_ADDRESS: 'MULTILINE_ADDRESS',
    MLA_COUNTRY: 'MLA_COUNTRY',
    MLA_CITY: 'MLA_CITY',
    MLA_ADDRESS_LINE: 'MLA_ADDRESS_LINE',
    MLA_ADDRESS_LINE_2: 'MLA_ADDRESS_LINE_2',
    MLA_POSTAL_CODE: 'MLA_POSTAL_CODE',
    MLA_SUBDIVISION: 'MLA_SUBDIVISION',
    MLA_STREET_NAME: 'MLA_STREET_NAME',
    MLA_STREET_NUMBER: 'MLA_STREET_NUMBER',
    MLA_APARTMENT: 'MLA_APARTMENT',
    FULL_NAME_FIRST_NAME: 'FULL_NAME_FIRST_NAME',
    FULL_NAME_LAST_NAME: 'FULL_NAME_LAST_NAME',
    FULL_NAME: 'FULL_NAME',
    VAT_ID: 'VAT_ID',
    SIGNATURE: 'SIGNATURE',
    DATE_PICKER: 'DATE_PICKER',
    RATING_INPUT: 'RATING_INPUT',
    TAGS: 'TAGS',
    PASSWORD: 'PASSWORD',
    IMAGE_CHOICE: 'IMAGE_CHOICE',
    PHONE: 'PHONE'
};
export const SHEDULING_FIELD_TYPES = {
    APPOINTMENT: 'APPOINTMENT',
    SERVICES_DROPDOWN: 'SERVICES_DROPDOWN',
    SERVICES_MULTI_CHOICE: 'SERVICES_MULTI_CHOICE'
};
export const PAYMENTS_FIELD_TYPES = {
    PRODUCT_LIST: 'PRODUCT_LIST',
    DONATION: 'DONATION',
    PAYMENT_INPUT: 'PAYMENT_INPUT',
    FIXED_PAYMENT: 'FIXED_PAYMENT'
};
export const EVENTS_FIELD_TYPES = {
    EVENTS_RSVP: 'EVENTS_RSVP',
    EVENTS_REPEATER: 'EVENTS_REPEATER'
};
export const INPUT_FIELD_TYPES = {
    ...CONTACTS_FIELD_TYPES,
    ...CHALLENGES_FIELD_TYPES,
    ...QUIZ_FIELD_TYPES,
    ...DEXT_FIELD_TYPES,
    ...SHEDULING_FIELD_TYPES,
    ...ECOM_FIELD_TYPES,
    ...BOOKINGS_FIELD_TYPES,
    ...PAYMENTS_FIELD_TYPES,
    ...COMMON_FIELD_TYPES,
    ...EVENTS_FIELD_TYPES
};
// Some INPUT_FIELD_TYPES entries have keys that differ from their persisted
// `view.fieldType` values (e.g. CHALLENGES_NUMBER → 'QUIZ_NUMBER'), so both the
// runtime check and the InputFieldType union must be derived from values, not keys.
const INPUT_FIELD_TYPE_VALUES = Object.values(INPUT_FIELD_TYPES);
export const isInputFieldType = (fieldType)=>fieldType && INPUT_FIELD_TYPE_VALUES.includes(fieldType);
const QUIZ_FIELD_TYPE_VALUES = Object.values(QUIZ_FIELD_TYPES);
export const isQuizFieldType = (fieldType)=>!!fieldType && QUIZ_FIELD_TYPE_VALUES.includes(fieldType);

//# sourceMappingURL=input-field-types.js.map